import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import * as Icon from 'react-feather';
import { whatsappOrderUrl } from '@loop-coffee/commerce-contracts';

import LogoLight from '../../assets/images/logo-light.png';
import { POLICIES } from '../policies/content';

const font = "'Space Grotesk', sans-serif";
export const mono = "'Space Grotesk', monospace";
export const panel = { background: '#111', borderRadius: 8, padding: 24, fontFamily: font };
export const contactLink = whatsappOrderUrl('Olá! Vim pelo site da Loop Coffee e preciso de ajuda com meu pedido.');

export function Alert({ children, tone = 'error', role = 'alert' }) {
    const background = tone === 'error' ? 'rgba(190,30,45,0.2)' : 'rgba(109,46,145,0.25)';
    return (
        <div role={role} className="p-3 mb-3 rounded text-white" style={{ background, fontSize: 14 }}>
            {children}
        </div>
    );
}

/** Page frame shared by the checkout and the payment return page. */
export function CheckoutShell({ title, children }) {
    return (
        <main style={{ background: '#0a0a0a', minHeight: '100vh', paddingTop: 40, paddingBottom: 80 }}>
            <Container>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <Link to="/"><img src={LogoLight} alt="Loop Coffee" height="60" /></Link>
                    <Link to="/" className="text-white-50" style={{ fontFamily: mono, fontSize: 13 }}>
                        <Icon.ArrowLeft size={14} className="me-1" />voltar_à_loja()
                    </Link>
                </div>
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <h1 className="text-white mb-3" style={{ fontFamily: font, fontWeight: 700, fontSize: '2rem' }}>
                            {title}
                        </h1>
                        {children}
                        {/* New tab, so reading a policy does not drop the customer out of the current step. */}
                        <nav aria-label="Políticas da loja" className="text-white-50 mt-4" style={{ fontSize: 12 }}>
                            Ao comprar na Loop Coffee você concorda com as nossas políticas:{' '}
                            {POLICIES.map((policy, index) => (
                                <React.Fragment key={policy.path}>
                                    {index > 0 && ' · '}
                                    <a href={policy.path} target="_blank" rel="noopener noreferrer">{policy.label}</a>
                                </React.Fragment>
                            ))}
                            .
                        </nav>
                        {/* Removed once the owner approves the policy texts (commerce-go-live PRP-004 AC-5). */}
                        <p className="text-white-50 mt-2" style={{ fontSize: 12 }}>
                            Textos e políticas provisórios, sujeitos a revisão. Dúvidas? <a href={contactLink} target="_blank" rel="noopener noreferrer">Fale conosco</a>.
                        </p>
                    </Col>
                </Row>
            </Container>
        </main>
    );
}
